'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/get-intrinsic/~/function-bind/index.js
// module id = 995
// module chunks = 0